import { render, staticRenderFns } from "./UbicacionDetail.vue?vue&type=template&id=81314a48&scoped=true"
import script from "./UbicacionDetail.vue?vue&type=script&lang=js"
export * from "./UbicacionDetail.vue?vue&type=script&lang=js"
import style0 from "./UbicacionDetail.vue?vue&type=style&index=0&id=81314a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81314a48",
  null
  
)

export default component.exports